export const TYPES = {
  LINK: "LINK",
  QUESTIONNAIRE: "QUESTIONNAIRE",
};



// WEBPACK FOOTER //
// ./src/views/pages/stories/constants.js